import React from 'react';// eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import reactMixin from 'react-mixin';
import styles from './ChangePasswordModal.scss';
import baseComponent from '../../decorators/baseComponent';
import Header from '../Header';
import BaseReactComponent from '../Util/BaseReactComponent';
import {changePasswordUser} from '../../actioncreators/InstallerCompanyActions';
import {connect} from 'react-redux';
import PasswordInput from 'react-password-input';
import LinkedStateMixin from 'react-addons-linked-state-mixin';
import { Form, ValidatedInput } from 'react-bootstrap-validation';
import Modal from 'react-bootstrap/lib/Modal';
import Password from 'try-react-password-input';


@connect()
@baseComponent(styles)
@reactMixin.decorate(LinkedStateMixin) class ChangePasswordModal extends BaseReactComponent {

    constructor(props) {
        super(props);

        this.state = {};
        this.state.newPassword = '';
        this.state.newPasswordValid = false;
    }

    componentWillMount() {
        //this.props
    }

    keyup(e) {
        if (e.which === 13) {
            this.changePassword(e);
        }
    }

    cancelChange() {
        this.setState({
            newPassword: '',
            newPasswordValid: false
        });

        this.props.onHide();
    }

    handleChange(key, event) {
        let update = {};
        update[key] = event.currentTarget.value;
        this.setState(update);
    }

    onPasswordChange = (v) => {
      let self = this;

      let newPassword = this.state.newPassword;
      let confirmPassword = v.confirmPassword;

      if (newPassword !== confirmPassword) {
        this.props.dispatch({
          type: 'CHANGE_PASSWORD_ERROR',
          text: this.getIntlMessage('error.password.dontmatch'),
          level: 'error',
          timeout: 5000
        })
      } else {
        changePasswordUser(this.props.user, newPassword, function (err) {
          if (!err) {
            self.setState({
              newPassword: '',
            });


            self.props.onHide();
            self.context.router.push('/');
          }
        })(self.props.dispatch);
      }
    };

    handleNewPasswordChange = (valid, password) => {
      this.setState({
        newPassword:password,
        newPasswordValid:valid
      });
    };

    render() {
        let requestForm = (
            <Form role="form" className="form-horizontal ChangePasswordModal" onKeyPress={this.keyup.bind(this)} onValidSubmit={this.onPasswordChange}>
              <div className="password-title">{this.getIntlMessage('changepasswordpage.change-password-description')}</div>
                <div className="form-group clearfix">
                    <label htmlFor="newPassword" className="col-sm-4 control-label">{this.getMessage('new-password-label')}</label>

                    <div className="col-sm-7">
                      <Password uppercase lowercase symbols digits noSpaces min={8} list={false} onChange={this.handleNewPasswordChange} className="new-password-input" />
                    </div>
                </div>
                <div className="form-group clearfix">
                    <label htmlFor="confirmPassword" className="col-sm-4 control-label">{this.getMessage('confirm-password-label')}</label>

                    <div className="col-sm-7">
                        <ValidatedInput name="confirmPassword"
                                        type="password"
                                        className="validate"
                                        id="confirmPassword"
                                        onChange={this.handleChange.bind(this, 'confirmPassword')}
                                        value={this.state.confirmPassword}
                                        validate="required"
                                        errorHelp={{
                                          required: 'Please confirm the new password'
                                        }}
                            />


                    </div>
                </div>
                <div className="controls">
                    <button className="btn btn-primary" disabled={!this.state.newPasswordValid}>{this.getMessage('save-button')}</button>
                    <a className="btn btn-link" onClick={this.cancelChange.bind(this)}>{this.getMessage('cancel-button')}</a>
                </div>
            </Form>);


        return (
            <Modal title={this.getIntlMessage('changepasswordpage.change-password-label')} onHide={this.props.onHide.bind(this)} show={this.props.show}>
                <Modal.Header>
                    <h3>{this.getMessage('change-password-title')}</h3>
                </Modal.Header>

                <Modal.Body>
                    {requestForm}
                </Modal.Body>
            </Modal>
        );
    }
}

ChangePasswordModal.propTypes = {
    user: React.PropTypes.object,
    show: React.PropTypes.bool,
    onHide: React.PropTypes.func
};

export default ChangePasswordModal;



// WEBPACK FOOTER //
// /src/components/ChangePasswordModal/ChangePasswordModal.js